import React from 'react';
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import * as Sentry from "@sentry/react";
import store from './store';
import App from './App';
import './index.css';

import * as serviceWorker from './serviceWorker';


Sentry.init({
  dsn: "https://0b96d5c4fb1d65ee0e241916fb0eb30f@o4508835517431808.ingest.us.sentry.io/4508835572285440",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	<Provider store={store}>
      <App />
    </Provider>
);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();